export const SINGLE_PRODUCT_PAGE_SLUG = "/single-product";
export const WORK_ORDER_GUEST_FORM_SLUG = "/work-order-guest-form";
export const PERSISTENT_SELECTED_BUILDING = "bhBuilding";
export const PERSISTENT_SELECTED_LANGUAGE = "bhLanguage";
